import { render, staticRenderFns } from "./AdminImportDrivers.vue?vue&type=template&id=8185e1de&scoped=true&"
import script from "./AdminImportDrivers.vue?vue&type=script&lang=js&"
export * from "./AdminImportDrivers.vue?vue&type=script&lang=js&"
import style0 from "./AdminImportDrivers.vue?vue&type=style&index=0&id=8185e1de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8185e1de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8185e1de')) {
      api.createRecord('8185e1de', component.options)
    } else {
      api.reload('8185e1de', component.options)
    }
    module.hot.accept("./AdminImportDrivers.vue?vue&type=template&id=8185e1de&scoped=true&", function () {
      api.rerender('8185e1de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminImportDrivers.vue"
export default component.exports